import styled from 'styled-components';

const isDarkTheme = (theme: { colors: { text: string; white: string } }): boolean => (
  theme.colors.text === theme.colors.white
);

const Wrapper = styled.div`
  .search-box {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.black : props.theme.colors.white
  )};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 100px;
    gap: 8px;
    width: 420px;

    .input-search {
      width: 100%;
      color: ${(props) => props.theme.colors.text};
      background: transparent;

      &::placeholder {
        color: ${(props) => props.theme.colors.inactive};
      }
    }

    .btn-search {
      width: 20px;
      height: 20px;
      color: ${(props) => props.theme.colors.main_cta};
      background: transparent;
      border: none;
      padding: 0;
      cursor: pointer;

      .icon {
        width: 100%;
        height: 100%;
      }
    }

    .btn-search-history {
      width: 20px;
      height: 20px;
      color: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.white : props.theme.colors.inactive
  )};
      background: transparent;
      border: none;
      padding: 0;
    }
  }
`;

export default { Wrapper };
